
export const servicesColumns = [
  {
    id: 'nombre',
    label: 'Nombre',
    sortable: true,
    type: 'text',
    required: true,
  },
  {
    id: 'tipo',
    label: 'Tipo',
    sortable: true,
    type: 'select',
    required: true,
    options: [
      { value: 'Agua', label: 'Agua' },
      { value: 'Agua caliente', label: 'Agua caliente' },
      { value: 'Gas', label: 'Gas' },
      { value: 'Electricidad', label: 'Electricidad' },
      { value: 'Internet', label: 'Internet' },
    ]
  },
  {
    id: 'contador',
    label: 'Contador',
    sortable: true,
    type: 'number',
    required: true
  },
  {
    id: 'planta', 
    label: 'Planta', 
    type: 'select', 
    sortable: true, 
    required: true,
    options: [] // Se llenarán dinámicamente desde el componente padre
  },
  {
    id: 'proveedor',
    label: 'Proveedor',
    sortable: true,
    type: 'text',
    required: true,
  },
  {
    id: 'unidad',
    label: 'Unidad',
    sortable: true,
    type: 'select',
    required: true,
    options: [
      { value: 'kwh', label: 'kwh' },
      { value: 'galones', label: 'galones' },
      { value: 'litros', label: 'litros' },
      { value: 'm3', label: 'm3' },
    ],
  },
  {
    id: 'precio',
    label: 'Precio',
    sortable: true,
    type: 'number',
    required: true,
  },
  {
    id: 'createdAt',
    label: 'Fecha de Creación',
    type: 'date',
    cell: ({ row }) => new Date(row.original.createdAt).toLocaleDateString(),
  },
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    required: true,
    options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ],
    render: (row) => row.estado,
  },
];

export const columnsExcel = [
  { header: 'Nombre', key: 'nombre', width: 20 },
  { header: 'Contador', key: 'contador', width: 15 },
  { header: 'Planta', key: 'planta.nombre', width: 25 },
  { header: 'Proveedor', key: 'proveedor', width: 25 },
  { header: 'Fecha de Creación', key: 'createdAt', width: 20 },
  { header: 'Estado', key: 'estado', width: 15 },
];
